import React from "react";
import NoAuth from "./no-auth";

const ContactSales = () => {
  return (
    <div style={{ height: "100vh" }}>
      <iframe
        src="https://meetings-eu1.hubspot.com/marcus-w-christensen?embed=true"
        style={{ width: "100%", height: "100%", border: "0" }}
        title="HubSpot Meetings"
        allow="geolocation; microphone; camera"
      />
    </div>
  );
};

export default <NoAuth title="Contact Sales" component={ContactSales} />;